import { Form, Formik } from "formik";
import { Modal } from "react-bootstrap";
import { Button, ThemeProviderV2 } from '@blueprint/ui';
import "react-datepicker/dist/react-datepicker.css";
import { useModal } from "react-modal-hook";

import { useBankAccountList } from "../../../api/bankAccount";

import { Loader } from "../../../common/components/core";
import { SelectField } from "../../../common/components/form";

type FilterHandler = {
    show: () => void;
    hide: () => void;
};

export type FilterBankAccountValues = {
    userProfileId?: number;
    pageNo: number;
};

const useFilterHandler = (
    currentFilter: FilterBankAccountValues,
    onSubmit: (value: FilterBankAccountValues) => void,
): FilterHandler => {
    const { data: bankAccounts = [] } = useBankAccountList();

    const profileNameOptions = bankAccounts
        .filter(
            (item, index, array) =>
                array.findIndex((item3) => item.userProfile.id !== undefined && item.userProfile.id === item3.userProfile.id) === index,
        )
        .map((item) => ({
            value: item.userProfile.id ? item.userProfile.id + "" : "",
            label: item.userProfile.name ?? "",
        }));

    const onResetHandler = () => {
        onSubmit({
            userProfileId: undefined,
            pageNo: 0,
        });
        hide();
    };

    const [show, hide] = useModal(() => {
        return (
            <ThemeProviderV2>
            <Modal show backdrop centered onHide={hide} id="filter-modal">
                <Formik
                    validateOnBlur={false}
                    validateOnChange={false}
                    onSubmit={(value: FilterBankAccountValues) => {
                        onSubmit({
                            ...value,
                        });
                        hide();
                    }}
                    initialValues={{
                        ...currentFilter,
                    }}
                >
                    {({ handleSubmit, isSubmitting }) => (
                        <Loader isLoading={isSubmitting}>
                            <Modal.Header>
                                <h2 className="mb-0">Filter</h2>
                            </Modal.Header>
                            <Modal.Body>
                                <Form
                                    autoComplete="off"
                                    noValidate
                                    onSubmit={handleSubmit}
                                >
                                    <SelectField
                                        name="userProfileId"
                                        label="Profile Name"
                                        menuPosition="fixed"
                                        options={profileNameOptions}
                                    />
                                    <Modal.Footer className="justify-content-between px-0 pb-0 pt-4">
                                        <Button
                                            variant="light.tertiary"
                                            type="reset"
                                            onClick={onResetHandler}
                                        >
                                            Reset
                                        </Button>
                                        <Button variant="light.primary" type="submit">
                                            Apply
                                        </Button>
                                    </Modal.Footer>
                                </Form>
                            </Modal.Body>
                        </Loader>
                    )}
                </Formik>
            </Modal>
            </ThemeProviderV2>
        );
    }, [bankAccounts, currentFilter]);

    return {
        show,
        hide,
    };
};


export default useFilterHandler;
